import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import LayoutContext from "./context";
import Header from "./Header";
import Body, { BodyFooter, BodyHeader } from "./Body";
import Footer from "./Footer";
import { MENUS } from "./constant";
const LayoutComponent = ({ children, page = "" }) => {
    const [breadcrumbs, setBreadcrumbs] = useState(page);
    const listBreadcrumbs = useMemo(() => {
        if (Array.isArray(breadcrumbs))
            return breadcrumbs;
        switch (breadcrumbs) {
            case "all_form":
                return [MENUS.ALL_FORM];
            default:
                return [];
        }
    }, [breadcrumbs]);
    const contextValue = {
        setBreadcrumbs,
        listBreadcrumbs
    };
    return (_jsx(LayoutContext.Provider, { value: contextValue, children: _jsx("div", { className: "te-flex te-flex-col te-min-h-screen te-bg-main te-h-screen", children: children }) }));
};
const Layout = LayoutComponent;
Layout.Container = LayoutComponent;
Layout.Header = Header;
Layout.BodyHeader = BodyHeader;
Layout.Body = Body;
Layout.BodyFooter = BodyFooter;
Layout.Footer = Footer;
export default Layout;
